export default __webpack_public_path__ + "static/media/front-end.69b90e39.svg";